(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-page-aide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-vq-help-root]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var search = root.querySelector('[data-vq-help-search]');
    var clear = root.querySelector('[data-vq-help-clear]');
    var reset = root.querySelector('[data-vq-help-reset]');
    var count = root.querySelector('[data-vq-help-count]');
    var empty = root.querySelector('[data-vq-help-empty]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-vq-help-item]'));
    var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('.vqa__category[data-vq-help-category]'));
    var currentCategory = 'all';

    function normalize(value) {
      return (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }

    function applyFilters() {
      var query = normalize(search.value);
      var visible = 0;
      items.forEach(function (item) {
        var inCategory = currentCategory === 'all' || item.dataset.category === currentCategory;
        var haystack = normalize(item.textContent + ' ' + item.dataset.keywords);
        var matches = !query || haystack.indexOf(query) !== -1;
        item.hidden = !(inCategory && matches);
        if (!item.hidden) visible += 1;
      });
      clear.hidden = !query;
      reset.hidden = currentCategory === 'all' && !query;
      empty.hidden = visible !== 0;
      count.textContent = visible + (visible > 1 ? ' réponses disponibles' : ' réponse disponible');
    }

    function selectCategory(category) {
      currentCategory = category || 'all';
      categoryButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.vqHelpCategory === currentCategory));
      });
      applyFilters();
    }

    root.addEventListener('click', function (event) {
      var category = event.target.closest('[data-vq-help-category]');
      if (category) {
        search.value = '';
        selectCategory(category.dataset.vqHelpCategory);
        root.querySelector('.vqa__content-grid').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var opener = event.target.closest('[data-vq-help-open]');
      if (opener) {
        var target = document.getElementById(opener.dataset.vqHelpOpen);
        if (!target) return;
        search.value = '';
        selectCategory('all');
        target.hidden = false;
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () { target.querySelector('summary').focus(); }, 400);
        return;
      }
      if (event.target.closest('[data-vq-help-reset]')) {
        search.value = '';
        selectCategory('all');
        search.focus();
      }
    });

    search.addEventListener('input', applyFilters);
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        search.value = '';
        applyFilters();
      }
    });
    clear.addEventListener('click', function () {
      search.value = '';
      applyFilters();
      search.focus();
    });
    applyFilters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vq-page-education"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-vqe-root]');
  if(!root||root.dataset.ready==='true')return;
  root.dataset.ready='true';
  var input=root.querySelector('#VqeSearch');
  var clear=root.querySelector('[data-vqe-clear]');
  var cards=Array.prototype.slice.call(root.querySelectorAll('[data-vqe-card]'));
  var filters=Array.prototype.slice.call(root.querySelectorAll('[data-vqe-filter]'));
  var quick=Array.prototype.slice.call(root.querySelectorAll('[data-vqe-quick]'));
  var jumps=Array.prototype.slice.call(root.querySelectorAll('[data-vqe-jump]'));
  var routes=Array.prototype.slice.call(root.querySelectorAll('[data-vqe-route-card]'));
  var result=root.querySelector('[data-vqe-result]');
  var empty=root.querySelector('[data-vqe-empty]');
  var grid=root.querySelector('[data-vqe-grid]');
  var active='all';
  var frame=0;
  var labels={all:'tous les sujets',sommeil:'le sommeil',stress:'le stress et la relaxation',energie:'l’énergie et la concentration',poids:'la prise de poids',recuperation:'le sport et la récupération'};
  var aliases={nuit:'sommeil',dormir:'sommeil',repos:'sommeil',reveil:'sommeil',calme:'stress',detente:'stress',anxiete:'stress',cortisol:'stress',focus:'energie',concentration:'energie',fatigue:'energie',vitalite:'energie',grossir:'poids',masse:'poids',appetit:'poids',hypermass:'poids',muscle:'recuperation',musculaire:'recuperation',sport:'recuperation',entrainement:'recuperation',courbature:'recuperation',amino:'recuperation'};
  var ignored={de:1,des:1,du:1,la:1,le:1,les:1,un:1,une:1,et:1,pour:1,au:1,aux:1};
  function normalize(value){return(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();}
  var items=cards.map(function(card){
    var topic=card.getAttribute('data-vqe-topic')||'general';
    return{node:card,topic:topic,terms:normalize(topic+' '+card.getAttribute('data-vqe-search'))};
  });
  function tokenize(value){
    return normalize(value).split(/\s+/).filter(function(token){return token.length>1&&!ignored[token];});
  }
  function tokenMatches(terms,token){
    return terms.indexOf(token)!==-1||(aliases[token]&&terms.indexOf(aliases[token])!==-1);
  }
  function updateRoutes(){
    routes.forEach(function(link){
      if(active!=='all'&&link.getAttribute('data-vqe-route-card')===active)link.setAttribute('aria-current','true');
      else link.removeAttribute('aria-current');
    });
  }
  function run(){
    frame=0;
    var query=normalize(input?input.value:'');
    var tokens=tokenize(query);
    var visible=0;
    items.forEach(function(item){
      var matchesTopic=active==='all'||item.topic===active;
      var matchesWords=tokens.length===0||tokens.every(function(token){return tokenMatches(item.terms,token);});
      var show=matchesTopic&&matchesWords;
      if(item.node.hidden===show)item.node.hidden=!show;
      if(show)visible+=1;
    });
    if(clear)clear.hidden=!(input&&input.value);
    if(empty)empty.hidden=visible!==0;
    if(grid)grid.hidden=visible===0;
    if(result){
      if(active==='all'&&!query)result.textContent=visible+(visible>1?' guides disponibles':' guide disponible');
      else if(query&&active!=='all')result.textContent=visible+(visible>1?' guides trouvés pour ':' guide trouvé pour ')+'« '+query+' » dans '+labels[active];
      else if(query)result.textContent=visible+(visible>1?' guides trouvés pour ':' guide trouvé pour ')+'« '+query+' »';
      else result.textContent=visible+(visible>1?' guides sur ':' guide sur ')+labels[active];
    }
    updateRoutes();
    root.removeAttribute('aria-busy');
  }
  function schedule(){
    root.setAttribute('aria-busy','true');
    if(frame)window.cancelAnimationFrame(frame);
    frame=window.requestAnimationFrame(run);
  }
  function updateHash(){
    if(!window.history||!window.history.replaceState)return;
    var hash=active==='all'?'#VqeArticles':'#guides-'+active;
    if(window.location.hash!==hash)window.history.replaceState(null,'',window.location.pathname+window.location.search+hash);
  }
  function setFilter(value,scroll,writeHash){
    active=value||'all';
    filters.forEach(function(button){button.setAttribute('aria-pressed',button.getAttribute('data-vqe-filter')===active?'true':'false');});
    run();
    if(writeHash)updateHash();
    if(scroll){var target=root.querySelector('#VqeArticles');if(target)target.scrollIntoView({behavior:'smooth',block:'start'});}
  }
  if(input){
    input.addEventListener('input',schedule);
    input.addEventListener('keydown',function(event){if(event.key==='Escape'&&input.value){input.value='';run();}});
  }
  if(clear)clear.addEventListener('click',function(){input.value='';input.focus();run();});
  filters.forEach(function(button){button.addEventListener('click',function(){setFilter(button.getAttribute('data-vqe-filter'),true,true);});});
  quick.forEach(function(button){button.addEventListener('click',function(){if(input)input.value='';setFilter(button.getAttribute('data-vqe-quick'),true,true);});});
  jumps.forEach(function(link){link.addEventListener('click',function(){if(input)input.value='';setFilter(link.getAttribute('data-vqe-jump'),false,false);});});
  var reset=root.querySelector('[data-vqe-reset]');
  if(reset)reset.addEventListener('click',function(){if(input)input.value='';setFilter('all',false,true);});
  var hashMatch=window.location.hash.match(/^#guides-(sommeil|stress|energie|poids|recuperation)$/);
  if(hashMatch)setFilter(hashMatch[1],false,false);
  else run();
})();

  } catch(e) { console.error(e); }
})();
})();
